import { Link, Typography } from "@mui/material";
import get from "lodash/get";
import { FieldProps, useRecordContext } from "react-admin";
import { AddressDisplay } from "../../misc/AddressDisplay";
import { PostalAddress } from "../../model/PostalAddress";
import { getGoogleMapsUrl } from "../../utils/getGoogleMapsUrl";

export const PostalAddressField = (props: { source: string } & FieldProps) => {
  const { source, emptyText } = props;
  const record = useRecordContext(props);
  const postalAddress: PostalAddress = get(record, source);

  if (!postalAddress || (!postalAddress.city && !postalAddress.street && !postalAddress.geoCoordinates)) {
    return <Typography variant="body2">{emptyText}</Typography>;
  }

  const googleMapsUrl = getGoogleMapsUrl(postalAddress);

  const address = (
    <Typography variant="body2">
      <AddressDisplay address={postalAddress} />
    </Typography>
  );

  if (!googleMapsUrl) {
    return address;
  }

  return (
    <Link
      href={googleMapsUrl}
      underline="none"
      aria-label="Öffnen in Google Maps"
      target="_blank"
      rel="noopener noreferrer"
    >
      {address}
    </Link>
  );
};
